;(function () {
    const GARMENT = "line-item[data-monogram-guid]"
    const MONOGRAM = "line-item[data-monogram-line]"

    function findLine(selector, test) {
        return (
            Array.from(document.querySelectorAll(selector)).find(test) || null
        )
    }

    function partnerFor(item) {
        if (!item || item.id == null || item.quantity == null) return null

        const garment = findLine(
            GARMENT,
            (line) => line.dataset.id === String(item.id)
        )
        if (!garment) return null

        const guid = garment.dataset.monogramGuid
        if (!guid) return null

        const monogram = findLine(
            MONOGRAM,
            (line) => line.dataset.monogramLine === guid
        )
        if (!monogram || !monogram.dataset.id) return null

        return { id: monogram.dataset.id, quantity: item.quantity }
    }

    function install() {
        const Form = window.HandleFormDataJSON
        if (!Form) return false
        if (Form.prototype.monogramPaired) return true

        const updateItems = Form.prototype.updateItems

        Form.prototype.updateItems = function (item) {
            try {
                const partner = partnerFor(item)
                if (partner && this.APIobj) {
                    this.APIobj.updateFormItems(partner)
                }
            } catch (error) {
                console.error(error)
            }

            return updateItems.call(this, item)
        }

        Form.prototype.monogramPaired = true
        return true
    }

    if (!install()) document.addEventListener("DOMContentLoaded", install)
})()
